import React from "react";

const emptyResults = () => (
  <div className="card w-75 mx-auto mt-4">
    <div className="card-body">
      <div className="card-title">
        <h4 className="fw-bold">No PRs found matching this search.</h4>
      </div>
      <hr />
      <p>We&apos;ve got a PR representative ready and raring to chat about any topic you&apos;re exploring.</p>
      <p className="mb-0">A little tweak to your search could really sweeten your results!</p>
    </div>
  </div>
);

export default emptyResults;
